import { Box, Typography } from '@mui/material'
import './style.scss'
import FormHelper from '../helpers/FormHelper'

function Details ({ apr, tcredit, trepay, mrepay, excerpt, interval }) {
  const intervalText = FormHelper.Interval[interval - 1]
  return <Box className="calc-details-wrapper">
    <Typography variant="h4">
      {intervalText} REPAYMENT
    </Typography>
    <Typography variant="h2" className="mb-20">€{mrepay}</Typography>
    <Typography component="p" variant="body1">{excerpt}</Typography>
    <Typography variant="h6" className="calc-details-grid-title">Loan Details</Typography>
    <Box className="calc-details-grid">
      <Box className="calc-details-row">
        <Typography component="p" variant="body2">APR</Typography>
        <Typography variant="h6">{apr}%</Typography>
      </Box>
      <Box className="calc-details-row">
        <Typography component="p" variant="body2">Total Cost of Credit</Typography>
        <Typography variant="h6">{FormHelper.moneyFormatter.format(trepay)}</Typography>
      </Box>
      <Box className="calc-details-row">
        <Typography component="p" variant="body2">Total to Repay</Typography>
        <Typography variant="h6">{FormHelper.moneyFormatter.format(tcredit)}</Typography>
      </Box>
    </Box>

  </Box>
}

export default Details
